/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { EMPTY_STRING } from '@common/tech-shared';
import { booleanAttribute, Component, input, output } from '@angular/core';
import { ButtonComponent } from '../button/button.component';
import { RoutingButtonComponent } from '../routing-button/routing-button.component';

@Component({
  selector: 'ods-overview-list-page',
  template: `<h1 class="heading-1" data-test-id="overview-list-page-heading">{{ heading() }}</h1>
    @if (description()) {
      <p class="whitespace-pre-line" data-test-id="overview-list-page-description">{{ description() }}</p>
    }
    @if (addPath()) {
      <ods-routing-button
        [linkPath]="addPath()"
        [isRelativePath]="isRelativePath()"
        [text]="newButtonText()"
        [dataTestId]="buttonDataTestId()"
        [attr.data-test-id]="'overview-list-page-link-button'"
      />
    } @else if (newButtonText()) {
      <ods-button
        size="fit"
        [text]="newButtonText()"
        [dataTestId]="buttonDataTestId()"
        (clicked)="newButtonClick.emit()"
        [attr.data-test-id]="'overview-list-page-action-button'"
      />
    }
    @if (isEmpty()) {
      @if (emptyListText()) {
        <p data-test-id="overview-list-page-empty-list-text">{{ emptyListText() }}</p>
      }
    } @else {
      <ng-content />
    }`,
  imports: [RoutingButtonComponent, ButtonComponent],
  host: { class: 'flex flex-col gap-4 text-text' },
})
export class OverviewListPageComponent {
  public readonly heading = input.required<string>();
  public readonly description = input<string>(EMPTY_STRING);
  public readonly emptyListText = input<string>(EMPTY_STRING);
  public readonly newButtonText = input<string>(EMPTY_STRING);
  public readonly addPath = input<string>(EMPTY_STRING);
  public readonly isRelativePath = input(false, { transform: booleanAttribute });
  public readonly isEmpty = input(false, { transform: booleanAttribute });
  public readonly buttonDataTestId = input<string>(EMPTY_STRING);

  public readonly newButtonClick = output<void>();
}
